export enum VoteType {
  positive = '+',
  negative = '-',
}
